import React from 'react'
import './App.css';
import { useState, useEffect } from 'react';
import './index.css';
import Loader from './components/Loader'
import Nav from './components/Nav'
import Head_Img from './components/Head_Img'
import AboutContent from './components/AboutContent'
import Work from './components/Work'
import Get from './components/Get'
import Footer from './components/Footer'

const App = () => {

    return (
    <>
      <Loader />
      <Nav />
      <Head_Img />
      <AboutContent />
      <Work />
      <Get />
      <Footer />
      </>
    )
  
}

export default App;